import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { checkprotectedroutes, setActivity } from '../../Global/Index';
import HeaderOuter from '../Nav Bar/HeaderOuter.js';
import ShortcutButton from '../Layout Shortcut/Shortcut.jsx';
import FinancialCalculator from './InterestCalculator.js';
import { ToastContainer, toast } from 'react-toastify';


const EmiCalculator = () => {
  const encoded_token = Cookies.get('token');
  const [isAuthorized, setIsAuthorized] = useState(null); // State to track authorization

  useEffect(() => {
    const checkProtectedRoutes = async () => {
      setActivity('EMI Calculator Page')
      if (!encoded_token) {
        window.location.href = '/';
        return;
      }

      const isProtected = await checkprotectedroutes();
      if (!isProtected) {
        toast.warn('You are not authorized to access this page. Please login again.');
        Cookies.remove('token'); // Remove the token from cookies
        setIsAuthorized(false); // Set authorized state to false

      } else {
        setIsAuthorized(true); // Set authorized state to true
      }
    };

    checkProtectedRoutes();
  }, [encoded_token]); // Add token as a dependency

  if (!isAuthorized) {
    return <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    </div>; // Show a loading state while checking authorization
  } else {
    return (
      <>
        <ToastContainer />
        <HeaderOuter />
        <FinancialCalculator />
        <ShortcutButton />
      </>
    );
  }


};

export default EmiCalculator;